// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PodcastLibraryButton-cls1__ac0314f901ec896fa46c{/*!*/}.PodcastLibraryButton-cls2___8f83e4252a55ca4630e{margin-right:8px;display:flex;align-items:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "PodcastLibraryButton-cls1__ac0314f901ec896fa46c",
	"cls2": "PodcastLibraryButton-cls2___8f83e4252a55ca4630e PodcastLibraryButton-cls1__ac0314f901ec896fa46c"
};
export default ___CSS_LOADER_EXPORT___;
